import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as patientDataActions from '../actions/loading-state.actions';
import { PatientService } from '../../services/patient.service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class PatientEffects {
  constructor(private injector: Injector, private actions$: Actions) {}


  private getPatientService(): PatientService{
    return this.injector.get(PatientService);
  }

  @Effect()
  loadRequestEffect$: Observable<Action> = this.actions$.pipe(
    ofType<patientDataActions.FetchPatientDataAction>(
      patientDataActions.ActionTypes.FETCH_PATIENT_DATA
    ),
    switchMap(action => this.getPatientService()
        .getPatientData(action.payload.mrn)
        .pipe(
          map(
            patientData =>
              new patientDataActions.UpdatePatientDataAction({
                patientData
              })
          ),
          catchError(error =>
            {
              console.error('Failed to fetch patient data Error : ',error.message);
              return of(new patientDataActions.SetErrorAction({ error }))
})
        )
    )
  );
}
